/*!
 * Copyright Zendesk, Inc.
 * Use of this source code is governed under the Apache License, Version 2.0
 * found at http://www.apache.org/licenses/LICENSE-2.0
 */
!function (n, r) {
  for (var e in r) {
    n[e] = r[e];
  }
}(exports, function (n) {
  var r = {};

  function e(t) {
    if (r[t]) return r[t].exports;
    var o = r[t] = {
      i: t,
      l: !1,
      exports: {}
    };
    return n[t].call(o.exports, o, o.exports, e), o.l = !0, o.exports;
  }

  return e.m = n, e.c = r, e.d = function (n, r, t) {
    e.o(n, r) || Object.defineProperty(n, r, {
      enumerable: !0,
      get: t
    });
  }, e.r = function (n) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(n, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(n, "__esModule", {
      value: !0
    });
  }, e.t = function (n, r) {
    if (1 & r && (n = e(n)), 8 & r) return n;
    if (4 & r && "object" == typeof n && n && n.__esModule) return n;
    var t = Object.create(null);
    if (e.r(t), Object.defineProperty(t, "default", {
      enumerable: !0,
      value: n
    }), 2 & r && "string" != typeof n) for (var o in n) {
      e.d(t, o, function (r) {
        return n[r];
      }.bind(null, o));
    }
    return t;
  }, e.n = function (n) {
    var r = n && n.__esModule ? function () {
      return n.default;
    } : function () {
      return n;
    };
    return e.d(r, "a", r), r;
  }, e.o = function (n, r) {
    return Object.prototype.hasOwnProperty.call(n, r);
  }, e.p = "", e(e.s = 1);
}([function (n, r) {
  n.exports = require("react");
}, function (n, r, e) {
  "use strict";

  function t() {
    for (var n = arguments.length, r = new Array(n), e = 0; e < n; e++) {
      r[e] = arguments[e];
    }

    return function (n) {
      for (var e = arguments.length, t = new Array(e > 1 ? e - 1 : 0), o = 1; o < e; o++) {
        t[o - 1] = arguments[o];
      }

      return r.some(function (r) {
        return r && r.apply(void 0, [n].concat(t)), n && n.defaultPrevented;
      });
    };
  }

  e.r(r);
  var o = 0;

  function u() {
    var n = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "garden";
    return "".concat(n, "-").concat(o++);
  }

  function f(n) {
    o = n;
  }

  function c() {
    for (var n = arguments.length, r = new Array(n), e = 0; e < n; e++) {
      r[e] = arguments[e];
    }

    for (var t = 0, o = r; t < o.length; t++) {
      var u = o[t];
      if (void 0 !== u) return u;
    }
  }

  var i = e(0);

  function a() {
    for (var n = arguments.length, r = new Array(n), e = 0; e < n; e++) {
      r[e] = arguments[e];
    }

    var t = Object(i.useRef)(null);
    return Object(i.useEffect)(function () {
      r.forEach(function (n) {
        n && ("function" == typeof n ? n(t.current) : n.current = t.current);
      });
    }, []), t;
  }

  var l = {
    ALT: 18,
    BACKSPACE: 8,
    COMMA: 188,
    DELETE: 46,
    DOWN: 40,
    END: 35,
    ENTER: 13,
    ESCAPE: 27,
    HOME: 36,
    LEFT: 37,
    NUMPAD_ADD: 107,
    NUMPAD_DECIMAL: 110,
    NUMPAD_DIVIDE: 111,
    NUMPAD_ENTER: 108,
    NUMPAD_MULTIPLY: 106,
    NUMPAD_SUBTRACT: 109,
    PAGE_DOWN: 34,
    PAGE_UP: 33,
    PERIOD: 190,
    RIGHT: 39,
    SHIFT: 16,
    SPACE: 32,
    TAB: 9,
    UP: 38
  };
  e.d(r, "composeEventHandlers", function () {
    return t;
  }), e.d(r, "generateId", function () {
    return u;
  }), e.d(r, "setIdCounter", function () {
    return f;
  }), e.d(r, "getControlledValue", function () {
    return c;
  }), e.d(r, "useCombinedRefs", function () {
    return a;
  }), e.d(r, "KEY_CODES", function () {
    return l;
  });
}]));